import Vue from 'vue'

//--Declaro variables Globales
Vue.prototype.$globalVar = {
    PUBLIC_EST_DEFAULT: 'LA OROYA',

    PUBLIC_NUM_SISTEMA: '',
    PUBLIC_NOM_SISTEMA: '',
    APP_DIR_NRO: '',
    APP_DIR_GEO: '',
    APP_USER_CONNECT: '',
    APP_MESG_TITULO : 'VIGMON : Vigilancia Ambiental',
};